import { Divider, Grid, Typography } from '@mui/material';
import React from 'react';
import { useTheme } from "@mui/material/styles";
import EcmsComponentsGrid from '../EcmsComponents/EcmsComponentsGrid';


const ECMSConfigFinanceLandingPage = ({accordian}) => {
    const theme = useTheme();
    const values = [
        { name: "PayEntry Components", comp: <EcmsComponentsGrid /> },
    ];

    return (
        <Grid container spacing={2} style={{ padding: "10px 0px" }}>
            {values?.map((value, id) => (
              <React.Fragment key={id}>
                <Grid
                    item
                    xs={12}
                    md={value.name === "PayEntry Components" ? 12 : 6}
                    >
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{
                        paddingLeft: "15px",
                        color: theme.palette.primary.contrastText,
                        }}
                    >
                        {value.name}
                    </Typography>
                    {value?.comp}
                </Grid>
                {([0, 2, 3].includes(id)) && (
                    <Grid item xs={12}>
                        <Divider sx={{ my: 1 }} />
                    </Grid>
                )}
              </React.Fragment>

            ))}
        </Grid>
    );
};

export default ECMSConfigFinanceLandingPage;
